import type { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import ErrorBoundaryClass from "./class";

export type ErrorBoundaryFCProps = {
  errorPath?: string;
};
export const ErrorBoundary = ({
  children,
  errorPath,
}: PropsWithChildren<ErrorBoundaryFCProps>) => {
  const navigate = useNavigate();
  return (
    <ErrorBoundaryClass navigate={navigate} errorPath={errorPath}>
      {children}
    </ErrorBoundaryClass>
  );
};
